module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (5).1aff2fef.svg";